export default __webpack_public_path__ + "static/media/safari_settings_ios_17_ipad.f3d3beb2.png";